import { useCustomerLoginActions } from './customer-auth-actions/useCustomerLoginActions'
import { useCustomerSessionActions } from './customer-auth-actions/useCustomerSessionActions'
import { useGuestCartMerge } from './customer-auth-actions/useGuestCartMerge'
import type {
  ApplyAuthenticatedStateFn,
  ClearAuthStateFn,
  CustomerLoginActionResult,
} from './customer-auth-actions/actionTypes'

export type { CustomerLoginActionResult }

/**
 * Composes customer-auth actions (login/signup/refresh/logout/profile update).
 *
 * @param params Current token and auth-state mutation callbacks.
 * @returns Async auth actions bound to the current auth context.
 */
export const useCustomerAuthActions = ({
  token,
  applyAuthenticatedState,
  clearAuthState,
  setBusy,
  setError,
}: {
  token: string | null
  applyAuthenticatedState: ApplyAuthenticatedStateFn
  clearAuthState: ClearAuthStateFn
  setBusy: (value: boolean) => void
  setError: (value: string) => void
}) => {
  const mergeGuestCartAfterAuthentication = useGuestCartMerge()
  const loginActions = useCustomerLoginActions({
    applyAuthenticatedState,
    mergeGuestCartAfterAuthentication,
    setBusy,
    setError,
  })
  const sessionActions = useCustomerSessionActions({
    token,
    applyAuthenticatedState,
    clearAuthState,
    setBusy,
    setError,
  })

  return {
    ...loginActions,
    ...sessionActions,
  }
}
